import { PropsWithChildren } from "react";
import { Provider as ReduxDataProvider } from "react-redux";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { store } from "store";

export function GlobalDataProvider({ children }: PropsWithChildren<any>) {
  return (
    <ReduxDataProvider store={store}>
      {children} <NotificationContainer />
    </ReduxDataProvider>
  );
}
